import Route from '@ember/routing/route';

export default class XeroConnectRoute extends Route {}
